export enum TaxRateType {
  Upcoming,
  Current,
  Ended,
}
